import { render } from "./VatTuKhoTable.vue?vue&type=template&id=557a42d5&ts=true"
import script from "./VatTuKhoTable.vue?vue&type=script&lang=ts"
export * from "./VatTuKhoTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__